import { assets } from "../../../publics/assets";
import "./LegalMentionsPage.css";

const LegalMentionsPage = () => {
  return (
    <div className="lmp-root">
      <div className="lmp-container">
        {/* ── Header ── */}
        <header className="lmp-header">
          <div className="lmp-logo-area">
            <img
              src={assets.ActionLogoGray}
              alt="logo"
              className="lmp-action-logo"
            />
          </div>
          <div className="lmp-header-meta">
            {/* <span className="lmp-badge">Accès professionnel</span> */}
            <span className="lmp-version">Version du 30 juin 2026</span>
          </div>
        </header>

        <main className="lmp-body">
          {/* ══ MENTIONS LÉGALES ══ */}
          <h1 className="lmp-chapter">Mentions Légales</h1>
          <p className="lmp-subtitle">
            Plateforme SecuFire Action — accès professionnel
          </p>
          <p className="lmp-version-text">Version du 30 juin 2026</p>

          <section className="lmp-section">
            <h2>1. Éditeur de la plateforme</h2>
            <div className="lmp-field">
              <span className="lmp-label">Raison sociale :</span>
              <span className="lmp-value">Climate Innov SAS</span>
            </div>
            <div className="lmp-field">
              <span className="lmp-label">Siège social :</span>
              <span className="lmp-value">7 rue René Vietto — 06200 Nice</span>
            </div>
            <div className="lmp-field">
              <span className="lmp-label">SIREN :</span>
              <span className="lmp-value">930335195</span>
            </div>
            <div className="lmp-field">
              <span className="lmp-label">Directeur de la publication :</span>
              <span className="lmp-value">Pierre-Alain Revelat, Président</span>
            </div>
            <div className="lmp-field">
              <span className="lmp-label">Contact :</span>
              <span className="lmp-value">
                <a href="mailto:contact@climate-innov.com">
                  contact@climate-innov.com
                </a>
              </span>
            </div>
          </section>

          <section className="lmp-section">
            <h2>2. Partenaire scientifique</h2>
            <div className="lmp-field">
              <span className="lmp-label">Raison sociale :</span>
              <span className="lmp-value">
                EDHEC Business School — EDHEC Climate Institute
              </span>
            </div>
            <div className="lmp-field">
              <span className="lmp-label">Forme juridique :</span>
              <span className="lmp-value">Association loi 1901</span>
            </div>
            <div className="lmp-field">
              <span className="lmp-label">Siège social :</span>
              <span className="lmp-value">
                24 avenue Gustave Delory, 59057 Roubaix Cedex 01, France
              </span>
            </div>
            <div className="lmp-field">
              <span className="lmp-label">SIREN :</span>
              <span className="lmp-value">
                <em>à compléter</em>
              </span>
            </div>
            <div className="lmp-field">
              <span className="lmp-label">Représentante :</span>
              <span className="lmp-value">
                Camille Angué, Directrice de l'EDHEC Climate Institute
              </span>
            </div>
            <div className="lmp-field">
              <span className="lmp-label">Contact :</span>
              <span className="lmp-value">
                <a href="mailto:presse@climateimpactedhec.com">
                  presse@climateimpactedhec.com
                </a>
                {" · "}+33 4 93 18 78 87
              </span>
            </div>
          </section>

          <section className="lmp-section">
            <h2>3. Hébergement</h2>
            <div className="lmp-field">
              <span className="lmp-label">Hébergeur :</span>
              <span className="lmp-value">Amazon Web Services EMEA SARL</span>
            </div>
            <div className="lmp-field">
              <span className="lmp-label">Adresse :</span>
              <span className="lmp-value">
                38 Avenue John F. Kennedy - 1855 Luxembourg, Luxembourg
              </span>
            </div>
            <div className="lmp-field">
              <span className="lmp-label">Contact hébergeur :</span>
              <span className="lmp-value">
                <a href="mailto:aws-EU-privacy@amazon.com">
                  aws-EU-privacy@amazon.com
                </a>
              </span>
            </div>
            <div className="lmp-field">
              <span className="lmp-label">Site :</span>
              <span className="lmp-value">
                <a
                  href="https://aws.amazon.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Services de cloud computing – Amazon Web Services (AWS)
                </a>
              </span>
            </div>
          </section>

          <section className="lmp-section">
            <h2>4. Propriété intellectuelle</h2>
            <p>
              L'ensemble des contenus accessibles sur la plateforme SecuFire
              Action — données, textes, graphiques, interfaces, algorithmes,
              modèles de prédiction, logiciels et tout autre élément — sont
              protégés par les dispositions du Code de la propriété
              intellectuelle et demeurent la propriété exclusive de Climate
              Innov SAS et de l'EDHEC Climate Institute, ou de leurs partenaires
              scientifiques dûment référencés.
            </p>
            <p>
              Toute reproduction, représentation, modification, publication ou
              adaptation de tout ou partie de ces contenus, par quelque moyen
              que ce soit, est interdite sans l'autorisation écrite préalable de
              Climate Innov SAS et de l'EDHEC Climate Institute.
            </p>
            <p>
              Le modèle physique de propagation Balbi intégré dans SecuFire
              Action est la propriété intellectuelle du Projet Feur, laboratoire
              SPE (Sciences Pour l'Environnement), Università di Corsica
              Pasquale Paoli.
            </p>
          </section>

          <section className="lmp-section">
            <h2>5. Protection des données personnelles</h2>
            <p>
              La plateforme SecuFire Action est accessible exclusivement aux
              professionnels disposant d'un code d'accès personnel attribué dans
              le cadre d'une convention de partenariat avec Climate Innov SAS et
              l'EDHEC Climate Institute.
            </p>
            <p>
              Les données personnelles collectées dans ce cadre (identité,
              coordonnées professionnelles, logs de connexion) sont traitées
              conformément au Règlement Général sur la Protection des Données
              (RGPD — Règlement UE 2016/679) et à la loi n° 78-17 du 6 janvier
              1978 modifiée relative à l'informatique, aux fichiers et aux
              libertés.
            </p>
            <p>
              Conformément à la réglementation en vigueur, les utilisateurs
              disposent d'un droit d'accès, de rectification, de limitation et
              de suppression des données les concernant, exerçable à l'adresse :{" "}
              <a href="mailto:contact@climate-innov.com">
                contact@climate-innov.com
              </a>
              .
            </p>
            <p>
              <strong>Responsable de traitement :</strong> Climate Innov SAS — 7
              rue René Vietto — 06200 Nice.{" "}
              <a href="mailto:contact@climate-innov.com">
                contact@climate-innov.com
              </a>
            </p>
          </section>

          <section className="lmp-section">
            <h2>6. Cookies</h2>
            <p>
              La plateforme peut utiliser des cookies techniques strictement
              nécessaires à son fonctionnement (authentification, session
              utilisateur). Aucun cookie à des fins publicitaires ou de
              profilage n'est déposé. Les cookies de session sont supprimés à la
              fermeture du navigateur.
            </p>
          </section>

          <section className="lmp-section">
            <h2>7. Droit applicable</h2>
            <p>
              Les présentes mentions légales sont soumises au droit français. En
              cas de litige, et à défaut de résolution amiable, les tribunaux
              compétents du ressort du siège de la SAS Climate Innov seront
              seuls compétents.
            </p>
          </section>

          {/* ══ CGU ══ */}
        </main>

        <footer className="lmp-footer">
          <em>
            Climate Innov en partenariat scientifique avec EDHEC Climate
            Institute
          </em>
          <br />
          <a href="mailto:presse@climateimpactedhec.com">
            presse@climateimpactedhec.com
          </a>
          {" · "}
          <a href="mailto:contact@climate-innov.com">
            contact@climate-innov.com
          </a>
        </footer>
      </div>
    </div>
  );
};

export default LegalMentionsPage;
